import { useQuery, UseQueryOptions } from 'react-query';
import { QueryKeys } from '.';
import { useApi } from '../../context';
import { DealPartnerContact } from '../../models';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDealPartnerContactQuery(
	guid: string,
	options?: Omit<UseQueryOptions<DealPartnerContact[], unknown, DealPartnerContact[]>, 'queryKey' | 'queryFn'>
) {
	const api = useApi();
	return useQuery(
		QueryKeys.DealPartners.Contacts(guid),
		() =>
			AxiosUtils.getResponseData<DealPartnerContact[]>(api.get(CerebroApiEndpoints.DealPartners.Contacts(guid))),
		options
	);
}
